import React from 'react';
import ReactDOM from "react-dom";

import Main from "../../src/layout/top/top-main";

export default class AppUITopSharedView {

    constructor() {
        this.DOMElementId = 'ui-top-panel';

        this.topPanelSettings = null;
        this.component = null;
        this.state = 'empty';

        this.prevValue = {};
    }

    registerComponent(component) {
        this.component = component;
    }

    update(tps) {
        this.component.update(tps);
    }

    applyTopSetting(topPanelSettings) {
        if (!topPanelSettings) return this.empty();

        this.component.update(topPanelSettings);
        gd.layout.applyTopPanelSettings(topPanelSettings);
    }

    empty() {
        this.component.update(false);
        gd.layout.applyTopPanelSettings(false);
    }


    render() {
        ReactDOM.render(<Main app={this} />,document.getElementById(this.DOMElementId));
    }
}